/******
 *
 * SMS API
 * 전화번호 문자 인증 시 사용
 ******* 현재 없어진 플로우로, 사용하지 않고 있음. *******
 ******/

import Request from "@/utils/Request";

export default {
  createEnc() {
    return Request({
      url: "/sms/create_enc",
      method: "post"
    });
  },
  sendSms(data) {
    return Request({
      url: "/sms/send_sms",
      method: "post",
      data
    });
  },
  checkCert(data) {
    return Request({
      url: "/sms/check_cert",
      method: "post",
      data
    });
  }
};
